'use strict';

const withProps = (View) => View.extend({
    initialize: function(options = {}) {
        const resourcesData = Odigeo._.get(options, 'resources', {});
        this.name = this.name || options.name;
        this.templates = Odigeo._.get(resourcesData, 'templates', {});
        this.keys = Odigeo._.get(resourcesData, 'keys', {});
        this.options = Odigeo._.get(options, 'options', {});
        this.id = options.id || this.$el.attr('id');
        View.prototype.initialize.call(this, options);
    },
});

module.exports = withProps;
